import { HttpClient } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { AgrEnvironment, EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';

import { GetVariantsResponse } from '../models/product-delivery.models';

@Injectable({
  providedIn: 'root',
})
export class ProductDeliveryApiService {
  protected baseUrl = this.env.APIM_BASE_URL + '/cart-v2-service';

  constructor(
    protected http: HttpClient,
    @Inject(EnvironmentInjector) private env: AgrEnvironment,
  ) {}

  public getVariants(productId: number): Observable<GetVariantsResponse> {
    return this.http.get<GetVariantsResponse>(`${this.baseUrl}/supplements/${productId}/variants`);
  }
}
